import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-lexgosign-sign',
  templateUrl: './lexgosign-sign.component.html',
  styleUrls: ['./lexgosign-sign.component.scss'],
  standalone: false
})
export class LexgosignSignComponent implements OnInit {
  @Input() signingUrl: string;
  @Input() recipientName = '';
  @Input() documentName = '';

  safeUrl: SafeResourceUrl | null = null;
  iframeBlockedHint = false;

  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    if (this.signingUrl) {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.signingUrl);
      // Si Lexgo bloquea iframe (X-Frame-Options), el usuario usa "Abrir en pestaña"
      setTimeout(() => {
        this.iframeBlockedHint = true;
      }, 2500);
    }
  }

  openExternal() {
    if (this.signingUrl) {
      window.open(this.signingUrl, '_blank', 'noopener,noreferrer');
    }
  }

  close(done = false) {
    this.activeModal.close(done);
  }
}
